// Third Party Plugins
import React, { forwardRef, ReactNode } from 'react';
// Styles
import { StyledCardLinkContainer } from './styles';

interface CustomLinkProps {
  href: string;
  children: ReactNode;
}

const CustomLink = forwardRef<HTMLAnchorElement, CustomLinkProps>(
  ({ href, children }, ref) => {
    return (
      <StyledCardLinkContainer as={'a'} ref={ref} href={href}>
        {children}
      </StyledCardLinkContainer>
    );
  },
);

CustomLink.displayName = 'CustomLink';

export default CustomLink;
